import { render, staticRenderFns } from "./integralModal.vue?vue&type=template&id=52f4251c&"
import script from "./integralModal.vue?vue&type=script&lang=js&"
export * from "./integralModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports